/**
 * #976: the browser transport. `apiFetch` adds the bearer token (and one
 * refresh on 401); the auth session epoch changes on login, logout and
 * account switch, which the client uses to drop late replies.
 */
import { apiFetch, getAuthSessionEpoch } from '@/stores/authStore';
import type { CardAnnotationTransport } from './types';

export const browserCardAnnotationTransport: CardAnnotationTransport = {
  send: (path, init) => apiFetch(path, init),
  epoch: getAuthSessionEpoch,
};
